export default __webpack_public_path__ + "static/media/logo-global-goals-sdg.6897f74b.svg";